/**
 * Created by vaibhav on 2/4/18
 */
import React from 'react';
import PropTypes from 'prop-types';

const FAQ = ({question, answer}) => {
    return (
        <div
            className="content faqbox"
            style={{border: '1px solid #eaecee', padding: '2em 4em'}}>
            <p><strong>{question}</strong> </p>
            <p>{answer}</p>
        </div>
    );
};

FAQ.propTypes = {
    question: PropTypes.string,
    answer: PropTypes.string,
};


export default FAQ


// WEBPACK FOOTER //
// ./src/components/FAQ/index.js